import { render, staticRenderFns } from "./ClientDomains.vue?vue&type=template&id=1e900745&"
import script from "./ClientDomains.vue?vue&type=script&lang=js&"
export * from "./ClientDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e900745')) {
      api.createRecord('1e900745', component.options)
    } else {
      api.reload('1e900745', component.options)
    }
    module.hot.accept("./ClientDomains.vue?vue&type=template&id=1e900745&", function () {
      api.rerender('1e900745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/ClientDomains.vue"
export default component.exports